import useDashboardConfig from 'hooks/useDashboardConfig';
import { createContext } from 'react';
import { configProfile, CustomBrandSettings } from 'types/dashboard-config';

type CustomDashboardConfigProviderProps = { children: React.ReactNode };
interface CustomDashboardConfigContextType {
    dashboardConfig: any;
    configProfileType: configProfile;
    fetchUserConfig: (profileId: string, companyId: string) => Promise<void>;
    fetchCompanyConfig: () => Promise<void>;
    updateUserConfig: (customConfig: CustomBrandSettings) => Promise<void>;
    updateCompanyConfig: (customConfig: CustomBrandSettings) => Promise<void>;
    removeUserConfig: () => Promise<void>;
    removeCompanyConfig: () => Promise<void>;
    createUserDashboardConfig: (customConfig: CustomBrandSettings) => Promise<void>;
    createCompanyDashboardConfig: (customConfig: CustomBrandSettings) => Promise<void>;
}
const defaultContextValue: CustomDashboardConfigContextType = {
    dashboardConfig: {},
    configProfileType: '',
    fetchUserConfig: async () => {},
    fetchCompanyConfig: async () => {},
    updateUserConfig: async () => {},
    updateCompanyConfig: async () => {},
    removeUserConfig: async () => {},
    removeCompanyConfig: async () => {},
    createUserDashboardConfig: async () => {},
    createCompanyDashboardConfig: async () => {}
};
export const CustomDashboardConfigContext = createContext<CustomDashboardConfigContextType>(defaultContextValue);

export default function CustomDashboardConfigProvider({ children }: CustomDashboardConfigProviderProps) {
    const {
        dashboardConfig,
        configProfileType,
        fetchUserConfig,
        fetchCompanyConfig,
        updateUserConfig,
        updateCompanyConfig,
        createUserDashboardConfig,
        createCompanyDashboardConfig,
        removeCompanyConfig,
        removeUserConfig
    } = useDashboardConfig();

    return (
        <CustomDashboardConfigContext.Provider
            value={{
                dashboardConfig,
                configProfileType,
                fetchUserConfig,
                updateUserConfig,
                fetchCompanyConfig,
                updateCompanyConfig,
                removeUserConfig,
                removeCompanyConfig,
                createUserDashboardConfig,
                createCompanyDashboardConfig
            }}
        >
            {children}
        </CustomDashboardConfigContext.Provider>
    );
}
